import React, { FC, Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import { IonPopover, IonToggle, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react'
import { cartMobx, discountMobx, doSwapBuyMobx, productMobx, restaurantConfig } from 'restaurant'
import { memberMobx, multiPersonMobx } from '@mobxStore'
import { localStore, useHistoryNew, modalLayer } from '@utils'
import { CashierController } from '@ctrls/index'
import { Avatar, Icon } from '@cps'
import { TimePickBar } from '@pages/checkout/component'
import CartProductItem from '../CartItem'
import MultiCartProductItem from '../MultiCartItem'
import { CartExChanges, CartGivens } from '../'
import { ExChangeModal, BoxPriceModal } from '../../modal'
import './index.scss'

const CartProduct: FC = () => {
  const nowPersonId = multiPersonMobx.currentPersonInfo?.personId
  const history = useHistoryNew()
  const { requiredProductResult } = cartMobx
  const [popoverUser, setPopoverUser] = useState({ showPopover: false, event: undefined })

  const handleShowTip = (e: any) => {
    e.persist()

    e.stopPropagation()

    setPopoverUser({ showPopover: true, event: e })
  }

  const handleAddRequiredProduct = (productNo: string, lackCnt: number) => {
    const product = productMobx.noToViewProductMap[productNo]
    if (product) {
      CashierController.handleProductToCart({ type: 'add', product, directAddCnt: lackCnt })
    }
  }

  // 选择换购
  const handleSelectExChange = (pks: string | string[]) => {
    let parentCartItemPk = String(pks)
    // 如果是数组（合并显示的时候），找到有换购机会的pk
    if (Array.isArray(pks)) {
      for (let i = 0; i < pks.length; i++) {
        if (discountMobx.discountResult.singleItemSwapBuyMap[pks[i]]?.surplusCnt) {
          parentCartItemPk = pks[i]
          break
        }
      }
    }
    doSwapBuyMobx.pick({ parentCartItemPk })
    modalLayer(ExChangeModal, {
    }).then((product: any) => {
      CashierController.addSwapBuyProduct(product, doSwapBuyMobx.doSwapBuy?.parentCartItem?.pk)
    }).catch(() => {
    })
  }

  // 删除换购
  const handleRemoveExchange = (targetItemPk: string, subPk: string) => {
    cartMobx.removeSwapBuyToCart(subPk, targetItemPk)
  }

  // 打包费详情
  const handleShowBoxPrice = () => {
    modalLayer(BoxPriceModal, {})
      .then(() => { })
      .catch(() => { })
  }

  useIonViewDidEnter(() => {
    if (!localStore.get('userInfoTips')) {
      const tipWrapper = document.getElementById('tipPop')
      tipWrapper && tipWrapper.click()
    }
  })

  useIonViewDidLeave(() => {
    cartMobx.setNeedPack(false)
  })

  return (
    <div className='cart-product-wrapper'>
      <TimePickBar type='order' />
      {!!requiredProductResult.items.length && (
        <div className='required-product-tip' data-cypid='requiredProductTip'>
          <div className='required-product-title'>
            <strong>{i18n.t('cart.requiredProductTitle')}</strong>
          </div>
          <div className='required-product-list'>
            {requiredProductResult.items.map(item => item.type === 'category' ? (
              <div className='required-product-item required-product-category-item' key={`${item.type}_${item.categoryNo}`}>
                <div className='required-product-category-title'>
                  <span className='required-product-name'>{item.name}</span>
                  <span className='required-product-lack'>{i18n.t('cart.requiredProductItemLack', { count: item.lackCnt })}</span>
                </div>
                <div className='required-product-options'>
                  {(item.products || []).map(product => (
                    <div className='required-product-option' key={product.productNo}>
                      <span className='required-product-name'>{product.name}</span>
                      <button type='button' disabled={!product.isAvailable} onClick={() => handleAddRequiredProduct(product.productNo, 1)}>
                        {i18n.t('cart.requiredProductAdd')} <Icon name='tianjia' />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className='required-product-item' key={`${item.type}_${item.productNo}`}>
                <div className='required-product-main'>
                  <span className='required-product-name'>{item.name}</span>
                  <span className='required-product-lack'>{i18n.t('cart.requiredProductItemLack', { count: item.lackCnt })}</span>
                </div>
                {item.productNo && (
                  <button type='button' onClick={() => handleAddRequiredProduct(item.productNo as string, item.lackCnt)}>
                    {i18n.t('cart.requiredProductAdd')} <Icon name='tianjia' />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {
        /** 多人点餐，本人未点餐 */
        !cartMobx.orderMerge && multiPersonMobx.isMultiPerson && !cartMobx.viewUserCartItems[multiPersonMobx.currentPersonInfo?.personId] ? (
          <section>
            <div
              className='user-info us-no-thing'
              data-cypid='multCartItemsMe'
              onClick={() => {
                (multiPersonMobx.currentPersonInfo?.personType === 'visitor' || !memberMobx.isLogin) && history.push('/visit/1')
              }}
            >
              <Avatar userKey={multiPersonMobx.currentPersonInfo?.personId} />
              <span>{multiPersonMobx.currentPersonInfo?.nickName}</span>
              {(multiPersonMobx.currentPersonInfo?.personType === 'visitor' || !memberMobx.isLogin) && (
                <>
                  <i className='iconfont icon-edit'></i>
                  <span id='tipPop' data-cypid='multCartItemsMeShowTip' onClick={handleShowTip}></span>
                </>
              )}
              <div className='no-thing'>{i18n.t('newCart.userNotItem')}</div>
            </div>
          </section>
        ) : null
      }
      {multiPersonMobx.isMultiPerson && !cartMobx.orderMerge && (
        <section>
          {cartMobx.viewUserCartUsers.map((user) => (
            <Fragment key={user}>
              <div
                className='user-info'
                data-cypid={`multCartItemsNoMerge_user_${user}`}
                onClick={() => {
                  (multiPersonMobx.multiPersonMap[user]?.personType === 'user' || multiPersonMobx.multiPersonMap[user]?.personType === 'visitor') &&
                  (nowPersonId === multiPersonMobx.multiPersonMap[user]?.personId) &&
                    history.push('/visit/1')
                }}
              >
                <Avatar userKey={user} />
                <span>{multiPersonMobx.multiPersonMap[user]?.nickName}</span>
                {(nowPersonId === multiPersonMobx.multiPersonMap[user]?.personId) && (multiPersonMobx.multiPersonMap[user]?.personType === 'user' || multiPersonMobx.multiPersonMap[user]?.personType === 'visitor') && restaurantConfig.member.key === user && (
                  <>
                    <i className='iconfont icon-edit'></i>
                    <span id='tipPop' data-cypid={`multCartItemsNoMergeShowTip_user_${user}`} onClick={handleShowTip}></span>
                  </>
                )}
              </div>
              {cartMobx.viewUserCartItems[user]
                .filter((item) => !item.isOrderSwapBuy)
                .map((cartItem, index) => {
                  return (
                    <div key={cartItem.pk}>
                      <CartProductItem cartItem={cartItem} index={index} />
                      <CartExChanges
                        cnt={
                          discountMobx.discountResult.singleItemSwapBuyMap[
                            cartItem.pk
                          ]?.surplusCnt
                        }
                        show={discountMobx.singleSwapBuyMap[cartItem.pk]?.canSwapBuy}
                        swapBuyProducts={cartItem.swapBuyProducts}
                        onSelect={() => handleSelectExChange(cartItem.pk)}
                        onRemove={(parentPk, subPk) => handleRemoveExchange(parentPk, subPk)}
                      />
                      <CartGivens fullItemNFreeProducts={cartItem.fullItemNFreeProducts} />
                    </div>
                  )
                })}
            </Fragment>
          ))}
        </section>
      )}
      {
        /** 多人合并购物车 */
        cartMobx.orderMerge && (
          <section>
            {cartMobx.viewCombinedCartItems.map((cartItem) => {
              let cnt = 0
              let canSwapBuy = false
              cartItem.pks.forEach((item) => {
                canSwapBuy = discountMobx.singleSwapBuyMap[item]?.canSwapBuy
                cnt +=
                  discountMobx.discountResult.singleItemSwapBuyMap[item]
                    ?.surplusCnt || 0
              })
              return (
                <div key={String(cartItem.pks)}>
                  <MultiCartProductItem cartItem={cartItem} />
                  <CartExChanges
                    cnt={cnt}
                    show={canSwapBuy}
                    swapBuyProducts={cartItem.swapBuyProducts}
                    onSelect={() => handleSelectExChange(cartItem.pks)}
                    onRemove={(parentPk, subPk) => handleRemoveExchange(parentPk, subPk)}
                  />
                  <CartGivens fullItemNFreeProducts={cartItem.fullItemNFreeProducts} />
                </div>
              )
            })}
          </section>
        )
      }
      {
        /** 单人购物车 */
        !multiPersonMobx.isMultiPerson && cartMobx.viewCartItems && (
          <section>
            {cartMobx.viewCartItems
              .filter((item) => item.cnt && !item.disabled)
              .filter((item) => !item.isOrderSwapBuy)
              .map((cartItem, index) => (
                <div key={cartItem.pk}>
                  <TimePickBar index={index} type='product' cartItem={cartItem} />
                  <CartProductItem cartItem={cartItem} index={index} />
                  <CartExChanges
                    show={discountMobx.singleSwapBuyMap[cartItem.pk]?.canSwapBuy}
                    cnt={
                        discountMobx.discountResult.singleItemSwapBuyMap[
                          cartItem.pk
                        ]?.surplusCnt
                    }
                    swapBuyProducts={cartItem.swapBuyProducts}
                    onSelect={() => handleSelectExChange(cartItem.pk)}
                    onRemove={(parentPk, subPk) => handleRemoveExchange(parentPk, subPk)}
                  />
                  <CartGivens fullItemNFreeProducts={cartItem.fullItemNFreeProducts} />
                </div>
              ))}
          </section>
        )
      }
      {!!cartMobx.viewDisabledCartItems.length && (
        cartMobx.viewDisabledCartItems
          .filter((item) => !item.isOrderSwapBuy)
          .map((cartItem, index) => (
            <div key={cartItem.pk}>
              <CartProductItem cartItem={cartItem} index={index} disabled={!!1} />
            </div>
          ))
      )}
      <IonPopover
        key='user'
        cssClass='cart-tips-popover'
        event={popoverUser.event}
        isOpen={popoverUser.showPopover}
        onDidDismiss={() => {
          localStore.set('userInfoTips', 'true')
          setPopoverUser({ showPopover: false, event: undefined })
        }}
      >
        <p>{i18n.t('newCart.userTips')}</p>
        <span
          onClick={(e: any) => {
            e.persist()
            setPopoverUser({ showPopover: false, event: undefined })
          }}
        >
          {i18n.t('newCart.know')}
        </span>
      </IonPopover>
    </div>
  )
}

export default observer(CartProduct)
